export const COMPANY_NOTIFICATION_RULES_SET_LOADING =
  'COMPANY_NOTIFICATION_RULES/SET_LOADING';
export const COMPANY_NOTIFICATION_RULES_SET_ERROR =
  'COMPANY_NOTIFICATION_RULES/SET_ERROR';
export const COMPANY_NOTIFICATION_RULES_SET_RULES =
  'COMPANY_NOTIFICATION_RULES/SET_RULES';
export const COMPANY_NOTIFICATION_RULES_SET_TYPES =
  'COMPANY_NOTIFICATION_RULES/SET_TYPES';

export const COMPANY_NOTIFICATION_RULES_FETCH_RULES =
  'COMPANY_NOTIFICATION_RULES/FETCH_RULES';
export const COMPANY_NOTIFICATION_RULES_FETCH_TYPES =
  'COMPANY_NOTIFICATION_RULES/FETCH_TYPES';
export const COMPANY_NOTIFICATION_RULES_CREATE_RULE =
  'COMPANY_NOTIFICATION_RULES/CREATE_RULE';
export const COMPANY_NOTIFICATION_RULES_UPDATE_RULE =
  'COMPANY_NOTIFICATION_RULES/UPDATE_RULE';
export const COMPANY_NOTIFICATION_RULES_DELETE_RULE =
  'COMPANY_NOTIFICATION_RULES/DELETE_RULE';
export const COMPANY_NOTIFICATION_RULES_CLEAR_ERROR =
  'COMPANY_NOTIFICATION_RULES/CLEAR_ERROR';

export const COMPANY_NOTIFICATION_RULES_GET_RULES =
  'COMPANY_NOTIFICATION_RULES/GET_RULES';
export const COMPANY_NOTIFICATION_RULES_GET_TYPES =
  'COMPANY_NOTIFICATION_RULES/GET_TYPES';
export const COMPANY_NOTIFICATION_RULES_GET_LOADING =
  'COMPANY_NOTIFICATION_RULES/GET_LOADING';
export const COMPANY_NOTIFICATION_RULES_GET_ERROR =
  'COMPANY_NOTIFICATION_RULES/GET_ERROR';
